import { Tecnico } from './tecnico.model';
import { NTECH_API , NTECH_API_2 } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class TecnicoService {

    constructor(private http: Http) {}

    getTecnicos(): Observable<Tecnico[]> {
        return this.http.get(`${NTECH_API}/tecnico`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }

    getTecnicoById(id: string): Observable<Tecnico> {
        return this.http.get(`${NTECH_API}/tecnico/${id}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }

    getDadosMapaOSById(id: string): Observable<any[]> {
        return this.http.get(`${NTECH_API_2}/sistema/mapa/tecnico/${id}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/tecnico/tecnico.service.ts